
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
    components: {}
})
export default class AddNewPatrolZone extends Vue {
  public hasValidationErrors: boolean = false;
  public showErrorAnimation: boolean = false;

  @Prop({
    default: () => ({
      title: {
        type: String,
        required: true
      }
    })
  })
  newZone: any;

  @Watch("newZone.title")
  onCallsignChanged(title: string) {
    this.hasValidationErrors = !title.length;
  }

  public isValid() {
    return this.newZone.title.length && this.newZone.zonePath;
  }

  public onSave() {
    if (this.isValid()) {
      this.hasValidationErrors = false;
      this.$emit("save", this.newZone);
    } else {
      this.hasValidationErrors = true;
      this.showErrorAnimation = true;

      setTimeout(() => {
        this.showErrorAnimation = false;
      }, this.$config.ANIMATION_DURATION);
    }
  }

  public onCancel() {
    this.$emit("cancel");
  }
}
